import axios from 'axios';

const baseUrl = process.env.REACT_APP_QCX_API_BASE_URL! + '/diduimp/report/processos-ref';

const generateSpreadsheetProcessosRef = async (
  token: string,
  unidadeId: number,
  clienteId?: string,
  processos?: string[],
  dataInicio?: string,
  dataFim?: string
) => {
  const params = new URLSearchParams();
  if (clienteId) {
    params.set('cliente', clienteId);
  }
  if (processos && processos.length > 0) {
    params.set('processos', processos.join(','));
  }
  if (dataInicio) {
    params.set('inicio', dataInicio);
  }
  if (dataFim) {
    params.set('fim', dataFim);
  }

  let message = null;

  try {
    const response = await axios.get(`${baseUrl}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        quickcomexTenant: unidadeId,
      },
      responseType: 'blob',
    });

    if (response.status === 200) {
      const file = new File([response.data], 'resumoProcessosRegistrados.xlsx', {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      message = await response.data.text();
    }
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.data) {
      message = await error.response.data.text();
    } else {
      message = 'Erro inesperado';
    }
  }

  return message;
};

export { generateSpreadsheetProcessosRef };
